// M7 e' servido na raiz do dominio (/), M4/M5/M6 em /m4, /m5, /m6 (nginx) -
// caminhos absolutos aqui, diferente do M6/alertas.html (servido sob /m6/,
// que precisava de caminho relativo).

const TOKEN_KEY = "telemetria_token";

export interface SessaoUsuario {
  token: string;
  tenantId: string | null;
  email: string;
  roles: string[];
  permissions: string[];
  // vazio = irrestrito (compatibilidade); configurado na pagina de usuario do M11.
  pageAccess: string[];
  layerAccess: string[];
}

export function sessaoAtual(): SessaoUsuario | null {
  const bruto = localStorage.getItem(TOKEN_KEY);
  if (!bruto) return null;
  try {
    const sessao = JSON.parse(bruto) as SessaoUsuario;
    // Sessoes salvas antes do pageAccess/layerAccess existirem (localStorage
    // de um login anterior a este deploy) nao tem esses campos - sem isso,
    // qualquer leitura de .length em sessao.pageAccess/layerAccess quebra.
    sessao.pageAccess = sessao.pageAccess || [];
    sessao.layerAccess = sessao.layerAccess || [];
    return sessao;
  } catch {
    return null;
  }
}

export function limparSessao(): void {
  localStorage.removeItem(TOKEN_KEY);
}

export async function login(email: string, senha: string): Promise<SessaoUsuario> {
  const resp = await fetch("/m4/auth/login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, senha }),
  });
  if (!resp.ok) {
    throw new Error("credenciais invalidas");
  }
  const dados = await resp.json();
  const sessao: SessaoUsuario = {
    token: dados.token,
    tenantId: dados.tenant_id,
    email,
    roles: dados.roles,
    permissions: dados.permissions,
    pageAccess: dados.pageAccess || [],
    layerAccess: dados.layerAccess || [],
  };
  localStorage.setItem(TOKEN_KEY, JSON.stringify(sessao));
  return sessao;
}

// Renova o token (8h de validade) antes de expirar, chamado periodicamente
// em main.ts enquanto o app estiver aberto - sem isso, o usuario e' deslogado
// no meio do uso so' por causa do prazo, mesmo continuando ativo. Falha
// silenciosa (ex: sessao ja expirou, ou 401) - a proxima chamada normal da
// API que falhar com 401 desloga do jeito de sempre.
export async function renovarSessao(): Promise<void> {
  const atual = sessaoAtual();
  if (!atual) return;
  try {
    const resp = await fetch("/m4/auth/refresh", {
      method: "POST",
      headers: { Authorization: `Bearer ${atual.token}` },
    });
    if (!resp.ok) return;
    const dados = await resp.json();
    const sessao: SessaoUsuario = {
      token: dados.token,
      tenantId: dados.tenant_id,
      email: atual.email,
      roles: dados.roles,
      permissions: dados.permissions,
      pageAccess: dados.pageAccess || [],
      layerAccess: dados.layerAccess || [],
    };
    localStorage.setItem(TOKEN_KEY, JSON.stringify(sessao));
  } catch {
    // sem internet/backend fora do ar - tenta de novo na proxima janela
  }
}
